import { finish, error } from 'src/modules/customers/actions/get-freebet-credits.js';

import api from 'src/api.js';

export function request(dispatch, { id }) {
    // TODO: Remove after redux refactor
    const isBonusEngineEnabled = $appState.configState.config.showBonusEngine;
    if (isBonusEngineEnabled) {
        $appState.trpcClient.client.bonusCampaignsRouter.getBonusBalance
            .mutate({
                accountId: id,
            })
            .then((responseBonusEngine) => {
                const freeBetFromResponse = responseBonusEngine.body['free-bet'];
                return {
                    bonusCredits: [],
                    totalAmount: freeBetFromResponse?.availableAmount ?? 0,
                };
            })
            .then(
                (data) => dispatch(finish(id, data)),
                ({ errors }) => dispatch(error(id, errors))
            );
    } else {
        api.get(`/user/freebet/${id}/credits`).then(
            (data) => dispatch(finish(id, data)),
            ({ errors }) => dispatch(error(id, errors))
        );
    }
}
